import React from "react";
import Cars from "./Tabs/Cars";
import Rentals from "./Tabs/Rentals";
import Customers from "./Tabs/Customers";
import Transfers from "./Tabs/Transfers";
import TransferePage from "../TransferPricing/TransferPricingManagement";
import Tours from "./Tabs/Tours";
import Drivers from "./Tabs/Drivers";
import EmployeeManagement from "../EmployeeManagement/EmployeeManagement";
import FinanceManagement from "../FinanceManagement/FinanceManagement";
import Coupons from "./Tabs/Coupons";
import PartnerManagement from "../PartnerManagement/PartnerManagement";
import Availability from "./Tabs/Availability";
import AadeIntegrationPanel from "../../pages/admin/AadeIntegrationPanel";
import RentalOptions from "./Tabs/RentalOptions";
import Handovers from "./Tabs/Handovers";
import OxygenInvoices from "../OxygenInvoices";
import AdminManagement from "./Tabs/AdminManagement";

function AdminDashBoardTabsContainer({
  activeTab,
  carsData,
  searchQuery,
  setSearchQuery,
  isCreatingCar,
  setCreateCarModalOpen,
  selectedCategory,
  setSelectedCategory,
  selectedTransmission,
  setSelectedTransmission,
  categories,
  paginatedCars,
  handleEditCar,
  getImagePath,
  handleCreateCar,
  createCarModalOpen,
  selectedCar,
  carDetailsModalOpen,
  setCarDetailsModalOpen,
  setSelectedCar,
  handleCarUpdate,
  handleCarDelete,
  handleSeasonSelect,
  updatingCarId,
  deletingCarId,
  deletingRentalId,
  deletingCouponId,
  settingSeasonalPrice,
  editingSeasonalPrice,
  setEditingSeasonalPrice,
  seasonalPricing,
  totalPages,
  setCarPage,
  carPage,
  LoadingSpinner,
  CreateCarModal,
  CarDetailsModal,
  currentPage,
  setCurrentPage,
  handleSetIsToday,
  handleSetIsTomorrow,
  handlePaymentStatusUpdate,
  filteredRentals,
  getDailyTurnover,
  getTomorrowTurnover,
  setTurnoverPage,
  turnoverPage,
  setDateFilter,
  dateFilter,
  totalRentalPages,
  rentalStatusFilter,
  rentalSearch,
  setRentalSearch,
  setRentalStatusFilter,
  setIsRentalModalOpen,
  fetchData,
  updatingRentalId,
  updatingPaymentId,
  setSelectedRental,
  setIsEditRentalModalOpen,
  handleRentalStatusUpdate,
  handleRentalDelete,
  formatDateTime,
  expandedCustomer,
  setExpandedCustomer,
  rentalsData,
  driversData,
  transfersData,
  partnersData,
  transferSearch,
  setTransferSearch,
  transferStatusFilter,
  setTransferStatusFilter,
  transferDateFilter,
  setTransferDateFilter,
  handleCreateTransfer,
  handleTransferStatusUpdate,
  updatingTransferStatus,
  handleUnassignDriver,
  handleAssignDriverToTransfer,
  assigningDriverToTransfer,
  handleTransferDelete,
  deletingTransferId,
  tourBookingsData,
  expandedTransfer,
  setExpandedTransfer,
  handleCreateTour,
  tours,
  toursData,
  tourBookings,
  handleEditTour,
  driverSearch,
  setDriverSearch,
  driverVehicleTypeFilter,
  setDriverVehicleTypeFilter,
  handleDriverCreate,
  handleDriverEdit,
  creatingDriver,
  editingDriver,
  changingDriverPassword,
  handleDriverPasswordChange,
  handleDriverDelete,
  deletingDriverId,
  couponsData,
  durationDiscounts,
  handleDurationDiscountUpdate,
  editingCoupon,
  setEditingCoupon,
  handleCouponEdit,
  creatingCoupon,
  handleCouponCreate,
  handleCouponDelete,
  serverSideRentals,
  allRentalsData,
}) {
  switch (activeTab) {
    case "cars":
      return (
        <Cars
          carsData={carsData}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          isCreatingCar={isCreatingCar}
          setCreateCarModalOpen={setCreateCarModalOpen}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedTransmission={selectedTransmission}
          setSelectedTransmission={setSelectedTransmission}
          categories={categories}
          paginatedCars={paginatedCars}
          handleEditCar={handleEditCar}
          getImagePath={getImagePath}
          handleCreateCar={handleCreateCar}
          createCarModalOpen={createCarModalOpen}
          selectedCar={selectedCar}
          carDetailsModalOpen={carDetailsModalOpen}
          setCarDetailsModalOpen={setCarDetailsModalOpen}
          setSelectedCar={setSelectedCar}
          handleCarUpdate={handleCarUpdate}
          handleCarDelete={handleCarDelete}
          handleSeasonSelect={handleSeasonSelect}
          updatingCarId={updatingCarId}
          deletingCarId={deletingCarId}
          settingSeasonalPrice={settingSeasonalPrice}
          editingSeasonalPrice={editingSeasonalPrice}
          setEditingSeasonalPrice={setEditingSeasonalPrice}
          seasonalPricing={seasonalPricing}
          totalPages={totalPages}
          setCarPage={setCarPage}
          carPage={carPage}
          LoadingSpinner={LoadingSpinner}
          CreateCarModal={CreateCarModal}
          CarDetailsModal={CarDetailsModal}
        />
      );
    case "rentals":
      return (
        <Rentals
          serverSideRentals={serverSideRentals}
          onSetIsTomorrow={handleSetIsTomorrow}
          onSetIsToday={handleSetIsToday}
          handlePaymentStatusUpdate={handlePaymentStatusUpdate}
          getDailyTurnover={getDailyTurnover}
          getTomorrowTurnover={getTomorrowTurnover}
          setTurnoverPage={setTurnoverPage}
          turnoverPage={turnoverPage}
          deletingRentalId={deletingRentalId}
          setIsRentalModalOpen={setIsRentalModalOpen}
          fetchData={fetchData}
          updatingRentalId={updatingRentalId}
          updatingPaymentId={updatingPaymentId}
          setSelectedRental={setSelectedRental}
          setIsEditRentalModalOpen={setIsEditRentalModalOpen}
          handleRentalStatusUpdate={handleRentalStatusUpdate}
          handleRentalDelete={handleRentalDelete}
          formatDateTime={formatDateTime}
          expandedCustomer={expandedCustomer}
          setExpandedCustomer={setExpandedCustomer}
        />
      );
    case "rentalOptions":
      return <RentalOptions />;
    case "customers":
      return (
        <Customers
          rentalsData={allRentalsData.allRentals}
          isLoading={allRentalsData.isLoading}
          refetch={allRentalsData.refetch}
          setSelectedRental={setSelectedRental}
          setIsEditRentalModalOpen={setIsEditRentalModalOpen}
        />
      );
    case "availability":
      return (
        <Availability
          rentalsData={allRentalsData.allRentals}
          isLoading={allRentalsData.isLoading}
          fetchRentalsForDateRange={allRentalsData.fetchRentalsForDateRange}
        />
      );
    case "handovers":
      return <Handovers />;
    case "oxygenInvoices":
      return <OxygenInvoices />;
    case "transfers":
      return (
        <Transfers
          driversData={driversData}
          transfersData={transfersData}
          partnersData={partnersData}
          fetchData={fetchData}
          transferSearch={transferSearch}
          setTransferSearch={setTransferSearch}
          transferStatusFilter={transferStatusFilter}
          setTransferStatusFilter={setTransferStatusFilter}
          transferDateFilter={transferDateFilter}
          setTransferDateFilter={setTransferDateFilter}
          handleCreateTransfer={handleCreateTransfer}
          handleTransferStatusUpdate={handleTransferStatusUpdate}
          updatingTransferStatus={updatingTransferStatus}
          handleUnassignDriver={handleUnassignDriver}
          handleAssignDriverToTransfer={handleAssignDriverToTransfer}
          assigningDriverToTransfer={assigningDriverToTransfer}
          handleTransferDelete={handleTransferDelete}
          deletingTransferId={deletingTransferId}
          tourBookingsData={tourBookingsData}
          expandedTransfer={expandedTransfer}
          setExpandedTransfer={setExpandedTransfer}
        />
      );
    case "transferPricing":
      return <TransferePage />;
    case "tours":
      return (
        <Tours
          handleCreateTour={handleCreateTour}
          tours={tours}
          toursData={toursData}
          tourBookings={tourBookings}
          tourBookingsData={tourBookingsData}
          handleEditTour={handleEditTour}
          fetchData={fetchData}
        />
      );
    case "drivers":
      return (
        <Drivers
          driversData={driversData}
          transfersData={transfersData}
          driverSearch={driverSearch}
          setDriverSearch={setDriverSearch}
          driverVehicleTypeFilter={driverVehicleTypeFilter}
          setDriverVehicleTypeFilter={setDriverVehicleTypeFilter}
          handleDriverCreate={handleDriverCreate}
          handleDriverEdit={handleDriverEdit}
          creatingDriver={creatingDriver}
          editingDriver={editingDriver}
          changingDriverPassword={changingDriverPassword}
          handleDriverPasswordChange={handleDriverPasswordChange}
          handleDriverDelete={handleDriverDelete}
          deletingDriverId={deletingDriverId}
        />
      );
    case "employees":
      return <EmployeeManagement />;
    case "finances":
      return <FinanceManagement />;
    case "coupons":
      return (
        <Coupons
          couponsData={couponsData}
          durationDiscounts={durationDiscounts}
          handleDurationDiscountUpdate={handleDurationDiscountUpdate}
          editingCoupon={editingCoupon}
          setEditingCoupon={setEditingCoupon}
          handleCouponEdit={handleCouponEdit}
          creatingCoupon={creatingCoupon}
          handleCouponCreate={handleCouponCreate}
          deletingCouponId={deletingCouponId}
          handleCouponDelete={handleCouponDelete}
        />
      );
    case "partners":
      return <PartnerManagement />;
    case "admins":
      return <AdminManagement />;
    default:
      return null;
  }
}

export default AdminDashBoardTabsContainer;
